<template>
	<div class="template-selector-modal">
		<Modal
			max-width="1000"
		>
			<template #modal-title>
				<IconButton
					v-if="currentStep === 'template-selection'"
					aria-label="Close modal"
					title="Close modal"
					tabindex="0"
					class="mr-2"
					@click="goBack"
					@keydown.enter="goBack"
					@keydown.space.prevent="goBack"
				>
					mdi-chevron-left
				</IconButton>
				<span v-if="currentStep === 'initial'">
					Create Consent Banner
				</span>
				<span v-else-if="currentStep === 'template-selection'">
					Select Template Type
				</span>
				<v-spacer />
				<IconButton
					aria-label="Close modal"
					title="Close modal"
					tabindex="0"
					@click="closeModal"
					@keydown.enter="closeModal"
					@keydown.space.prevent="closeModal"
				>
					mdi-close
				</IconButton>
			</template>

			<template #modal-content>
				<!-- Initial Step: Choose Template or Custom -->
				<div v-if="currentStep === 'initial'">
					<div class="text-center mb-6">
						<p class="text-body-1 text--secondary">
							Select from our library of legislation ready templates or start with your own custom configuration
						</p>
					</div>

					<v-row class="justify-center align-stretch">
						<v-col
							cols="12"
							sm="6"
							md="5"
							class="d-flex"
						>
							<OverviewCard
								title="Use Template"
								description="Use a pre-built template aligned with your applicable legislation"
								icon="mdi-file-document-outline"
								use-grey
								@overview="showTemplateOptions"
							/>
						</v-col>

						<!-- OR divider -->
						<v-col
							cols="12"
							sm="12"
							md="1"
							class="d-flex align-center justify-center"
						>
							<div class="text-body-1 text--secondary font-weight-medium">
								OR
							</div>
						</v-col>

						<v-col
							cols="12"
							sm="6"
							md="5"
							class="d-flex"
						>
							<OverviewCard
								title="Custom Configuration"
								description="Create a consent banner from scratch with control over all settings"
								icon="mdi-cog"
								use-grey
								@overview="selectCustom"
							/>
						</v-col>
					</v-row>
				</div>

				<!-- Template Selection Step -->
				<div v-else-if="currentStep === 'template-selection'">
					<v-row class="align-stretch">
						<v-col
							v-for="template in templateOptions"
							:key="template.id"
							cols="12"
							sm="6"
							md="4"
							class="d-flex"
						>
							<OverviewCard
								:title="template.title"
								:description="template.description"
								:icon="template.icon"
								use-grey
								@overview="() => selectTemplate(template.id)"
							/>
						</v-col>
					</v-row>
				</div>
			</template>
		</Modal>
	</div>
</template>

<script>
import Modal from '../../../../../../../shared/components/modal.vue'
import OverviewCard from '../../../../../../../shared/components/overview-card.vue'
import IconButton from '../../../../../../../shared/components/icon-button.vue'
import { templateOptions } from './banner-templates.js'

export default {
	name: 'template-selector-modal',
	components: {
		Modal,
		OverviewCard,
		IconButton
	},
	props: {
		showModal: {
			type: Boolean,
			default: false
		}
	},
	setup () {
		return {
			templateOptions
		}
	},
	data () {
		return {
			currentStep: 'initial' // 'initial' or 'template-selection'
		}
	},
	methods: {
		closeModal () {
			this.currentStep = 'initial' // Reset to initial step when closing
			this.$emit('close')
		},
		showTemplateOptions () {
			this.currentStep = 'template-selection'
		},
		selectTemplate (templateId) {
			this.$emit('template-selected', templateId)
			this.closeModal()
		},
		selectCustom () {
			this.$emit('custom-selected')
			this.closeModal()
		},
		goBack () {
			this.currentStep = 'initial'
		}
	}
}
</script>

<style lang="scss" scoped>
// Minimal styling using Vuetify classes
.template-selector-modal {
	// Card hover effects
	:deep(.overview-card) {
		transition: all 0.2s ease;
		cursor: pointer;

		&:hover {
			transform: translateY(-2px);
			box-shadow: 0 8px 16px rgba(0, 0, 0, 0.12);
		}
	}
}
</style>
